import "../../../../../css/CashflowModeller2/Buttons/AddEditButton.css"; // Import your CSS file
import { useState } from "react";

/**
 * AddEditButton component renders a customizable button for add/edit actions.
 *
 * @component
 *
 * @param {Object} props - Component props.
 * @param {string} [props.buttonText] - The label to display on the button. Defaults to "Add / Edit" if not provided.
 * @param {boolean} [props.isDisabled] - If true, the button appears disabled and applies the "disabled" CSS class.
 * @param {function} [props.onClick] - Optional callback function to execute when the button is clicked.
 *
 * @returns {JSX.Element} The rendered Add/Edit button component.
 */
const AddEditButton = ({ buttonText,isDisabled, onClick }) => {
  const [clicked, setClicked] = useState(false);
  // const handleClick = () => {
  //   navigate(link); // Navigate to the provided link
  // };

  // Render the Add/Edit button component
  return (
    <>
      <div
        className={`addeditButton  ${clicked ? "clicked" : ""} ${
          isDisabled ? "disabled" : ""
        } `}
        onClick={() => {
          setClicked(!clicked); // Toggle the clicked state
          // handleClick();
          onClick && onClick();
        }}
      >
        <div className="Label">{buttonText || "Add / Edit"}</div>
      </div>
    </>
  );
};

export default AddEditButton;
